import React, {useContext, useEffect, useState} from "react";
import { APIGetOrderReviews} from "../../api/orders/OrdersReviews";
import {GoCheckCircle, GoCircle, GoPlusCircle} from "react-icons/go";
import {OrderContext} from "../../context/OrderContext";
import {ReviewContext} from "../../context/ReviewContext";
import ReviewCreate from "../dialogs/reviewCreate";
import ReviewDetails from "../dialogs/reviewDetails";
import {ReviewDetailsView} from "../dialogs/reviewDetailsView";
import { UserContext } from "../../context/UserContext";

export default function Tasksreview(data) {

    const {order, userStatus} = useContext(OrderContext);
    const { user } = useContext(UserContext)
    const [review, setReview] = useState(null);
    const [currentPoint,setCurrentPoint] = useState(null);
    const [openReviewDetails, setOpenReviewDetails] = useState(false);
    const [openReviewCreate, setOpenReviewCreate] = useState(false);

    const setMap  = (_map) => {
        // placeholder review reload has no use here but in the viewer.js
    }

    const getViewItem = (item) => {
        return (
            <div key={review?.[item]?.id}  className={"flex justify-items-center justify-between cursor-pointer  text-sm leading-6 "}
                onClick={() => {
                    setCurrentPoint(review?.[item]);
                    setOpenReviewDetails(true);
                }}
            >
                <div className={"w-full shrink-1"}>
                    {(review?.[item]?.status === "done") ? (
                        <div title={"Bearbeitungsstatus: Abgeschlossen"} className={"flex pb-4  text-gray-600/60 text-sm text-left items-center mr-3"}>
                            <GoCheckCircle aria-hidden="true"  className="h-5 w-5 mr-4 flex-shrink-0"/>
                            {review?.[item]?.type === "error" ? (<span className="block w-[80px] text-center  flex-shrink-0 border border-red text-red rounded py-1 px-2 mr-2 text-xs mt-1 truncate font-medium ">Fehler</span>) : ""}
                            {review?.[item]?.type === "question" ? (<span className="block w-[80px] text-center  flex-shrink-0 border border-blue text-blue  rounded py-1 px-2 mr-2  text-xs mt-1 truncate font-medium ">Frage</span>) : ""}
                            {review?.[item]?.type === "reminder" ? (<span className="block w-[80px] text-center  flex-shrink-0 border border-orange text-orange rounded py-1 px-2 mr-2 text-xs mt-1 truncate font-medium">Erinnerung</span>) : ""}
                            {review?.[item]?.type === "request" ? (<span className="block w-[80px] text-center  flex-shrink-0 border border-green text-green rounded py-1 px-2 mr-2 text-xs mt-1 truncate font-medium ">Korrektur</span>) : ""}
                            {review?.[item]?.type === "additional" ? (<span className="block w-[80px] text-center  flex-shrink-0 border border-gray-900 text-gray-900 rounded py-1 px-2 mr-2 text-xs mt-1 truncate font-medium ">Änderung</span>) : ""}
                            <span className={" line-through"}>{review?.[item]?.name}</span>
                        </div>
                    ) : (
                        <div title={"Bearbeitungsstatus: Offen"}  className={"flex pb-4 text-sm text-gray-600/60 text-left items-center  mr-3"}>
                            <GoCircle  aria-hidden="true"  className=  "w-5 h-5 mr-4 flex-shrink-0" />
                            {review?.[item]?.type === "error" ? (<span className="block w-[80px] text-center  flex-shrink-0 border border-red text-red rounded py-1 px-2 mr-2 text-xs mt-1 truncate font-medium ">Fehler</span>) : ""}
                            {review?.[item]?.type === "question" ? (<span className="block w-[80px] text-center  flex-shrink-0 border border-blue text-blue rounded py-1 px-2 mr-2  text-xs mt-1 truncate font-medium ">Frage</span>) : ""}
                            {review?.[item]?.type === "reminder" ? (<span className="block w-[80px] text-center  flex-shrink-0 border border-orange text-orange rounded py-1 px-2 mr-2 text-xs mt-1 truncate font-medium">Erinnerung</span>) : ""}
                            {review?.[item]?.type === "request" ? (<span className="block w-[80px] text-center  flex-shrink-0 border border-green text-green rounded py-1 px-2 mr-2 text-xs mt-1 truncate font-medium ">Korrektur</span>) : ""}
                            {review?.[item]?.type === "additional" ? (<span className="block w-[80px] text-center  flex-shrink-0 border border-gray-900 text-gray-900 rounded py-1 px-2 mr-2 text-xs mt-1 truncate font-medium ">Änderung</span>) : ""}
                            <span>{review?.[item]?.name}</span>
                        </div>
                    )}
                </div>
            </div>
        )
    }

    const getEditItem = (item) => {

        return (
            <div key={review?.[item]?.id}  className={(review?.[item]?.status === "done") ?" rounded-md  flex items-center justify-between py-4  leading-6 ":" rounded-md  flex items-center justify-between py-4   text-sm leading-6 cursor-pointer"}>
                <div onClick={() => {
                    setCurrentPoint(review?.[item]);
                    setOpenReviewDetails(true);
                }}>
                    {(review?.[item]?.status === "done") ? (
                        <div title={"Bearbeitungsstatus: Abgeschlossen"} className={"flex  text-gray-600/60 text-sm text-left items-center mr-3"}>
                            <GoCheckCircle aria-hidden="true"  className="h-5 w-5 mr-4 flex-shrink-0"/>
                            {review?.[item]?.type === "error" ? (<span className="block w-[80px] text-center  flex-shrink-0 border border-red text-red rounded py-1 px-2 mr-2 text-xs mt-1 truncate font-medium ">Fehler</span>) : ""}
                            {review?.[item]?.type === "question" ? (<span className="block w-[80px] text-center  flex-shrink-0 border border-blue text-blue rounded py-1 px-2 mr-2  text-xs mt-1 truncate font-medium ">Frage</span>) : ""}
                            {review?.[item]?.type === "reminder" ? (<span className="block w-[80px] text-center  flex-shrink-0 border border-orange text-orange rounded py-1 px-2 mr-2 text-xs mt-1 truncate font-medium">Erinnerung</span>) : ""}
                            {review?.[item]?.type === "request" ? (<span className="block w-[80px] text-center  flex-shrink-0 border border-green text-green rounded py-1 px-2 mr-2 text-xs mt-1 truncate font-medium ">Korrektur</span>) : ""}
                            {review?.[item]?.type === "additional" ? (<span className="block w-[80px] text-center  flex-shrink-0 border border-gray-900 text-gray-900 rounded py-1 px-2 mr-2 text-xs mt-1 truncate font-medium ">Änderung</span>) : ""}
                            <span className={" line-through"}>{review?.[item]?.name}</span>
                        </div>
                    ) : (
                        <div title={"Bearbeitungsstatus: Offen"}  className={"flex text-sm text-gray-600/60 text-left items-center  mr-3"}>
                            <GoCircle  aria-hidden="true"  className=  "w-5 h-5 mr-4 flex-shrink-0" />
                            {review?.[item]?.type === "error" ? (<span className="block w-[80px] text-center  flex-shrink-0 border border-red text-red rounded py-1 px-2 mr-2 text-xs mt-1 truncate font-medium ">Fehler</span>) : ""}
                            {review?.[item]?.type === "question" ? (<span className="block w-[80px] text-center  flex-shrink-0 border border-blue text-blue rounded py-1 px-2 mr-2  text-xs mt-1 truncate font-medium ">Frage</span>) : ""}
                            {review?.[item]?.type === "reminder" ? (<span className="block w-[80px] text-center  flex-shrink-0 border border-orange text-orange rounded py-1 px-2 mr-2 text-xs mt-1 truncate font-medium">Erinnerung</span>) : ""}
                            {review?.[item]?.type === "request" ? (<span className="block w-[80px] text-center  flex-shrink-0 border border-green text-green rounded py-1 px-2 mr-2 text-xs mt-1 truncate font-medium ">Korrektur</span>) : ""}
                            {review?.[item]?.type === "additional" ? (<span className="block w-[80px] text-center  flex-shrink-0 border border-gray-900 text-gray-900 rounded py-1 px-2 mr-2 text-xs mt-1 truncate font-medium ">Änderung</span>) : ""}
                            <span>{review?.[item]?.name}</span>
                        </div>
                    )}
                </div>


            </div>
        )

    }


    useEffect(() => {
        try {
            APIGetOrderReviews({orderId: order?.id, companyId: user.companyId}).then((result) => {setReview(result)})
        } catch (error) {
            console.error('Error reading file from S3:', error);
        }
    }, [order?.id, user.companyId]);



    return (
        <div>
            <ReviewContext.Provider value={{id: order?.id,openReviewCreate,review, setReview,setMap, setOpenReviewCreate, openReviewDetails,setOpenReviewDetails, currentPoint, setCurrentPoint}}>
                <ReviewCreate/>
                {userStatus === "tenderOwner" || order?.stage !== "inReview" ? (
                    <ReviewDetailsView data={currentPoint}/>
                ) : (
                    <ReviewDetails data={currentPoint}/>
                )}   
            </ReviewContext.Provider>
            {(review !== null && Object.keys(review).length > 0) ? (
                <ul className={"mb-4"}>
                    { Object.keys(review)?.map((item) => {
                        if (userStatus === "tenderOwner" || order?.stage !== "inReview") {
                            return getViewItem(item);
                        } else {
                            return getEditItem(item);
                        }

                    })}
                </ul>
            ):(data?.data?.selectedVersion?.status !== "active") ? "Keine Einträge vorhanden":""}

            {(userStatus === "orderOwner" &&  order?.stage === "inReview" &&  data?.data?.selectedVersion?.status === "active") &&(
                <button 
                    type="button" 
                    onClick={() => {setOpenReviewCreate(true)}} 
                    className="inline-flex   border rounded border-gray-500 text-xs items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900  hover:bg-gray-50"
                >
                    <GoPlusCircle className={"h-4 w-5 mr-2"}/> Eintrag erfassen
                </button>
            )}
        </div>
    );

}


